export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/r.70aca5c.svg";